import { createListButtonStyles } from "@insite/content-library/Widgets/MyLists/MyListsCreateListButton";
import { css } from "styled-components";
// D:\johnstoncompanies\johnston\src\FrontEnd\modules\content-library\src\Widgets\MyLists\MyListsCreateListButton.tsx
createListButtonStyles.createListModal = {
    sizeVariant: "small",
    cssOverrides: {
        // modalTitle: css`
        //    // padding: 10px 20px;
        // `,
        modalContent: css`
            padding: 30px;
            overflow-y: auto;
            background-color: #ffffff;
            border: 1px solid #efefef;
            box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
        `,
    },
};
